export type VirtualTryOnJobStatus = "generating" | "completed" | "failed";

export type VirtualTryOnJob = {
  id: string;
  productName: string;
  sku: string;
  locale: string;
  variantId: string;
  status: VirtualTryOnJobStatus;
  errorKey?: string;
  previewBase64?: string;
  mimeType?: string;
  shareToken?: string;
};

export type VirtualTryOnGenerationResult = Required<
  Pick<VirtualTryOnJob, "previewBase64" | "mimeType" | "shareToken">
>;

export function getVirtualTryOnGenerationResult(
  response: unknown,
): VirtualTryOnGenerationResult | null {
  if (!response || typeof response !== "object") return null;

  const { previewBase64, mimeType, shareToken } = response as Record<string, unknown>;
  if (
    typeof previewBase64 !== "string" ||
    typeof mimeType !== "string" ||
    typeof shareToken !== "string" ||
    !previewBase64 ||
    !mimeType ||
    !shareToken
  ) {
    return null;
  }

  return { previewBase64, mimeType, shareToken };
}

export function updateVirtualTryOnJob(
  jobs: VirtualTryOnJob[],
  id: string,
  patch: Partial<Omit<VirtualTryOnJob, "id">>,
): VirtualTryOnJob[] {
  return jobs.map((job) => (job.id === id ? { ...job, ...patch } : job));
}
